import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SairRoutingModule } from './sair-routing.module';
import { SairComponent } from './sair.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [SairComponent], // Adicionado SairComponent
  imports: [
    CommonModule,
    SairRoutingModule,
    SharedModule]
})
export class SairModule { }
